import React, { useEffect, useState } from "react";
import SelectComp from "../../../components/Select";
import Input from "../../../components/Input";
import Button from "../../../components/ButtonUI";
import { Formik, useFormikContext } from "formik";
import {
  getAllCampaigns,
  deleteCampaign,
  addCampaign,
  updateCampaign,
  getCampaignByNumeroFacture,
} from "../../../api/screeningEvent";
import makeToast from "../../../components/Snackbar";
import Icon from "../../../components/Icon";
interface FormValues {
  clientId: string;
  numeroFacture: string;
  nbJournees?: number | null;
}

interface Props {
  clientList: any[];
  setShowAgendaModal: Function;
}

function CampagneForm({ clientList, setShowAgendaModal }: Props) {
  const [campaignList, setCampaignList] = useState<any[]>([]);
  const [numeroError, setNumeroError] = useState("");
  const [numeroFacture, setNumeroFacture] = useState("")

  const fetchCampaigns = async () => {
    const res = await getAllCampaigns();
    const list = Array.isArray(res) ? res : res.response || res.data || [];
    setCampaignList(list);
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  useEffect(() => {
    if (!numeroFacture) return;

    const timeout = setTimeout(async () => {
      const exists = await getCampaignByNumeroFacture(numeroFacture);
      setNumeroError(exists ? "Ce numéro de devis existe déjà" : "");
    }, 400);

    return () => clearTimeout(timeout);
  }, [numeroFacture]);

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-6 font-medium">
        <div className="w-full max-w-4xl h-full flex flex-col">
          <div className="block w-full rounded-3xl overflow-hidden text-left shadow-2xl bg-white flex-1 flex flex-col">
            <div
              className="flexCenter relative  text-white h-24  py-1"
              style={{ backgroundColor: "#4565f4" }}
            >
              {/* Close modal button */}
              <div className=" absolute right-0  top-0 rounded-bl-3xl border shadow-lg  cursor-pointer -mx-2 -my-2">
                <Icon
                  isIcon={true}
                  style={{ opacity: 0.5 }}
                  name="close"
                  onClick={() => {
                    setShowAgendaModal("");
                  }}
                />
              </div>
              <div className="">
                <span className="text-xl font-bold  leading-tight capitalize mx-2 w-2/3">
                  Ajouter une Campagne
                </span>
              </div>
            </div>
            <div className="flex-1 overflow-y-auto p-6 bg-gray-50">
              <Formik<FormValues>
                enableReinitialize={true}
                initialValues={{
                  clientId: "",
                  numeroFacture: "",
                  nbJournees: null,
                }}
                onSubmit={async (values, { resetForm }) => {
                  try {
                    if (!values.clientId || !values.nbJournees) {
                      makeToast("error","Veuillez remplir tous les champs");
                      return;
                    }

                    await addCampaign(values);
                    await fetchCampaigns();
                    resetForm();

                    makeToast("success","Campagne ajoutée avec succès !");
                  } catch (error) {
                    console.error(error);
                    makeToast("error", "Erreur lors de l'ajout de la campagne");
                  }

                }}
                validateOnChange={false}
                validateOnBlur={true}
              >
                {(formik) => {
                  const {
                    values,
                    setFieldValue,
                    handleSubmit,
                  } = formik;
                  
                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="max-w-2xl mx-auto mt-6 bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                        <h3 className="text-lg font-semibold text-gray-800 mb-6">
                          Nouvelle campagne
                        </h3>

                        {/* GRID */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          {/* Client */}
                          <div className="flex flex-col gap-1">
                            <label className="text-sm text-gray-500">
                              Client
                            </label>
                            <SelectComp
                              id="clientId"
                              value={values.clientId}
                              options={clientList}
                              onChange={(
                                e: React.ChangeEvent<HTMLSelectElement>,
                              ) => setFieldValue("clientId", e.target.value)}
                              text="Sélectionner le client"
                              className="h-11 border border-gray-200 rounded-xl"
                            />
                          </div>

                          {/* Nb journées */}
                          <div className="flex flex-col gap-1">
                            <label className="text-sm text-gray-500">
                              Nombre de journées
                            </label>
                            <Input
                              id="nbJournees"
                              type="number"
                              placeholder="Ex: 10"
                              value={values.nbJournees ?? ""}
                              onChange={(e) => {
                                const val = e.target.value.replace(
                                  /^0+(?=\d)/,
                                  "",
                                );
                                setFieldValue(
                                  "nbJournees",
                                  val === "" ? undefined : Number(val),
                                );
                              }}
                              className="h-11 rounded-xl"
                            />
                          </div>

                          {/* Num facture */}
                          <div className="flex flex-col gap-1 md:col-span-2">
                            <label className="text-sm text-gray-500">
                              Numéro de devis
                            </label>
                            <Input
                              id="numeroFacture"
                              type="text"
                              placeholder="Ex: DEV-2026-001"
                              value={values.numeroFacture ?? ""}
                              onChange={(e) =>{
                                const val = e.target.value
                                setFieldValue("numeroFacture", val)
                                setNumeroFacture(val)
                              }
                                
                              }
                              className="h-11 rounded-xl"
                            />
                            {numeroError && (
                              <p className="text-red-500 text-sm">
                                {numeroError}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* ACTIONS */}
                        <div className="flex justify-end gap-3 mt-8">
                          <Button
                            status="secondary"
                            type="button"
                            className="px-5 py-2 rounded-xl"
                            onClick={() => setShowAgendaModal("")}
                          >
                            Annuler
                          </Button>

                          <Button
                            status="primary"
                            type="submit"
                            disabled={numeroError? true : false}
                            className="px-6 py-2 rounded-xl font-medium"
                          >
                            Enregistrer
                          </Button>
                        </div>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CampagneForm;
